import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'globalCurrency'
})

export class GlobalCurrencyPipe implements PipeTransform {

  transform(value: number, currency: string | null | undefined): string {
    const currencyList: { shortname: string; symbol: string }[] = JSON.parse(localStorage.getItem('currency_List') || '[]');
    const formattedCurrency = (currency || 'INR').trim();
    const fractionDigits = formattedCurrency === 'INR' ? [0, 0] : [2, 2];
  
    const currencyObject = currencyList.find(item => item.shortname === formattedCurrency);
    if (!currencyObject) return value.toString();
  
    const formattedValue = new Intl.NumberFormat(
      formattedCurrency === 'INR' ? 'en-IN' : 'en-US', 
      { style: 'currency', currency: formattedCurrency, minimumFractionDigits: fractionDigits[0], maximumFractionDigits: fractionDigits[1] }
    ).format(value);
  
    return formattedValue.replace(formattedCurrency, currencyObject.symbol);
  }
  
}
